export default __webpack_public_path__ + "static/media/blackArrowLeft.86d55e84.svg";